document.addEventListener('DOMContentLoaded', function () {
	const burger = document.querySelector('.js-burger');
	const globalMenu = document.querySelector('.js-header-menu');
	const globalLogo = document.querySelector('.js-logo');
	const headerLinks = document.querySelectorAll('.p-header-list__link'); // 複数リンク

	//ヘッダー追従関数（上スクロール時、ページ最下部到達時のみ表示）
	headerScrollFunc();
	function headerScrollFunc() {
		const header = document.getElementById('js-header');

		//初期設定
		const options = {
			fixClass: 'is-fix', //追従class
			hideClass: 'is-hide', //追従中 非表示class
			showClass: 'is-show', //追従中 表示class
			showDelay: 100,
			//表示するまでのディレイ時間（指定秒数（ミリ秒）以上、下スクロールしなければ表示）
		};

		//ヘッダーが存在するかチェック
		if (!header) {
			return false;
		}

		//スクロール開始位置
		options.startPosi = 0;
		//上スクロール判別フラグ
		options.upFlg = false;
		//表示タイマー用設定
		options.setTimeoutFlg = false;
		options.setTimeoutId = 0;

		//ヘッダーfix関数呼び出し
		window.addEventListener('resize', function () {
			headerFix(options);
		});
		window.addEventListener('scroll', function () {
			headerFix(options);
		});

		//追従設定
		function headerFix(options) {
			//class設定
			const fixClass = options.fixClass;
			const showClass = options.showClass;
			const hideClass = options.hideClass;

			const headerBasePosi = 0;
			const headerFixPosi = header.clientHeight;
			//スクロール量（ウィンドウの上端）取得
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (window.innerWidth <= 768) {
				// トップページ(.front)で一番上に到達した場合
				if (header.classList.contains('front') && scrollTop <= headerBasePosi) {
					header.classList.remove(fixClass, showClass, hideClass);
					return;
				}

				// SPでは常に固定表示
				header.classList.add(fixClass, showClass);
				header.classList.remove(hideClass);
				return;
			}

			/*
			ヘッダーを追従させる位置
				画面の高さ、特定の要素の位置から追従開始など
				ヘッダーの高さを超えたら追従処理を開始
			*/

			//上下スクロール判別

			//下スクロール（新規取得したスクロール量がoptions.startPosiを超えている）
			if (scrollTop > options.startPosi) {
				//上スクロール判別フラグを無効化
				options.upFlg = false;

				//表示タイマーリセット
				clearTimeout(options.setTimeoutId);
				options.setTimeoutFlg = false;

				//スクロール量がヘッダーを追従させる位置を超えているか
				if (scrollTop > headerFixPosi) {
					//追従class追加
					header.classList.add(fixClass);
				}

				//ページの高さ取得
				const pageHeight = document.documentElement.scrollHeight;
				//下スクロール位置取得
				const scrollBottom = window.innerHeight + scrollTop;

				//ページの最下部だった場合はヘッダーを表示
				if (pageHeight <= scrollBottom) {
					headerShow(hideClass, showClass);

					//ページの途中だった場合
				} else {
					//表示されている場合ヘッダーを非表示
					if (header.classList.contains(showClass)) {
						headerHide(hideClass, showClass);
					}
				}

				//上スクロール（新規取得したスクロール量がoptions.startPosi以下）
			} else {
				//上スクロール判別フラグを有効化
				options.upFlg = true;

				//ヘッダーが追従前の位置に来ている場合は追従を終了する
				if (scrollTop <= headerBasePosi) {
					//全ての追従用classを削除
					header.classList.remove(fixClass, showClass, hideClass);

					//ヘッダーが追従前の位置を超えている場合
				} else {
					//表示タイマーが設定されていなければタイマーを設定
					if (!options.setTimeoutFlg) {
						//表示タイマーセット
						options.setTimeoutFlg = true;
						//指定秒数以上、下スクロールしていない場合のみヘッダーを表示
						options.setTimeoutId = setTimeout(function () {
							if (options.upFlg && header.classList.contains(fixClass)) {
								headerShow(hideClass, showClass);
							}
						}, options.showDelay);
					}
				}
			}

			//スクロール開始位置を更新
			options.startPosi = scrollTop;
		}

		//追従ヘッダー表示関数
		function headerShow(hideClass, showClass) {
			header.classList.remove(hideClass);
			header.classList.add(showClass);
		}

		//追従ヘッダー非表示関数
		function headerHide(hideClass, showClass) {
			header.classList.remove(showClass);
			header.classList.add(hideClass);
		}
	}

	burger.addEventListener('click', function () {
		if (!globalMenu.classList.contains('is-open')) {
			globalMenu.classList.add('is-open');
			burger.classList.add('is-active');
			globalLogo.classList.add('is-active');
		} else {
			globalMenu.classList.remove('is-open');
			burger.classList.remove('is-active');
			globalLogo.classList.remove('is-active');
		}
	});

	// リサイズ時に瞬時に消す
	let lastIsSP = window.innerWidth <= 768;

	window.addEventListener('resize', function () {
		const isSP = window.innerWidth <= 768;
		// PCからSPに初めて切り替わった瞬間だけ実行
		if (isSP && !lastIsSP) {
			// transitionを一時的に無効化し、すぐ消す
			globalMenu.style.transition = 'none';
			globalMenu.style.opacity = '0';
			globalMenu.style.visibility = 'hidden';
			globalMenu.style.pointerEvents = 'none';

			// SPになった瞬間
			globalMenu.classList.remove('is-open');
			burger.classList.remove('is-active');
			globalLogo.classList.remove('is-active');

			// 直後 CSS transitionを元に戻す
			setTimeout(() => {
				globalMenu.style.transition = '';
				globalMenu.style.opacity = '';
				globalMenu.style.visibility = '';
				globalMenu.style.pointerEvents = '';
			}, 20);
		}
		lastIsSP = isSP;
	});
	// リンククリック時でメニュー閉じる処理
	headerLinks.forEach(function (link) {
		link.addEventListener('click', function () {
			// SPビューのときだけ実行
			if (window.innerWidth <= 768) {
				globalMenu.classList.remove('is-open');
				burger.classList.remove('is-active');
				globalLogo.classList.remove('is-active');
			}
		});
	});

	// カレント表示の対象となるリンク要素を取得
	const links = document.querySelectorAll('.p-header-list__link');
	const currentPathname = location.pathname.replace(/\/$/, ''); // 末尾のスラッシュを削除

	links.forEach(function (link) {
		const linkPathname = link.pathname.replace(/\/$/, ''); // 末尾のスラッシュを削除

		// パスを分割して階層を取得
		const linkParts = linkPathname.split('/').filter((part) => part !== '');
		const currentParts = currentPathname.split('/').filter((part) => part !== '');

		// 第3階層の場合のみ処理
		if (linkParts.length >= 2) {
			const linkPath = linkPathname + '/';
			if (linkParts[1] === currentParts[1]) {
				link.classList.add('--current');
			}
		}
	});
});
